import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import {AuthProvider} from './context/AuthContext';
import {PeopleProvider} from './context/PeopleContext';
import {ThemeProvider} from '@/context/ThemeContext';
import {BrowserRouter} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <ThemeProvider>
                <AuthProvider>
                    <PeopleProvider>
                        <App/>
                    </PeopleProvider>
                </AuthProvider>
            </ThemeProvider>
        </BrowserRouter>

    </React.StrictMode>
);
